import { ElMessage } from 'element-plus';
import { useEmail } from '@/composables/useEmail';
import { getShareQuoteId, getShareValidity, runShare } from './shareHelpers';
import type { ShareContext } from './types';

export function useQuoteEmail({ sources, isChubbSelected, onEditDriver }: ShareContext) {
  const { isLoading: isSendingEmail, sendQuoteEmail } = useEmail();

  const handleSendEmail = async (): Promise<void> => {
    if (isChubbSelected.value) {
      ElMessage.info('El envío por correo no está disponible para Chubb en este momento.');
      return;
    }
    const idCotizacion = getShareQuoteId(sources);
    if (!idCotizacion) return;

    const personal = sources.quoteData.personalData;
    if (!personal?.email) {
      ElMessage.warning('Completa tus datos de contacto para enviar la cotización');
      onEditDriver();
      return;
    }

    await runShare(
      () =>
        sendQuoteEmail({
          idCotizacion: Number(idCotizacion),
          email: personal.email,
          telefono: personal.whatsapp,
          nombre: personal.fullName,
          prima: sources.quotesResponse.value?.Cobertura?.PrimaTotal ?? 0,
          fechaVigencia: getShareValidity(sources),
          quoteData: sources.quoteData,
        }),
      {
        success: 'Cotización enviada por correo electrónico',
        failureFallback: 'Error al enviar el email',
        unknownError: 'Error desconocido al enviar email',
      }
    );
  };

  return { isSendingEmail, handleSendEmail };
}
